import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const addSpeedLearnMapAsync = createAsyncThunk(
  "admin/addSpeedLearnMap",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addSpeedLearnMap`, payload, toolkit);
  }
);

export const getAllSpeedLearnMapAsync = createAsyncThunk(
  "admin/getAllSpeedLearnMap",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllSpeedLearnMap?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }`,
      [],
      toolkit
    );
  }
);

export const getSpeedLearnMapByIdAsync = createAsyncThunk(
  "admin/getSpeedLearnMapById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getSpeedLearnMap/${payload}`,
      [],
      toolkit
    );
  }
);

export const updateSpeedLearnMapAsync = createAsyncThunk(
  "admin/updateSpeedLearnMap",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateSpeedLearnMap`, payload, toolkit);
  }
);

export const deleteSpeedLearnMapAsync = createAsyncThunk(
  "admin/deleteSpeedLearnMap",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteSpeedLearnMap/${payload}`,
      [],
      toolkit
    );
  }
);

export const topicsByGoalIdAsync = createAsyncThunk(
  "admin/topicsByGoalId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/topicsByGoalId?goalId=${payload.goalId || ""}&subjectId=${
        payload.subjectId || ""
      }`,
      [],
      toolkit
    );
  }
);
